export enum KsefCredentialsRoleType {
    Owner = 'Owner',
    InvoiceRead = 'InvoiceRead',
    InvoiceWrite = 'InvoiceWrite',
    PaymentConfirmationWrite = 'PaymentConfirmationWrite',
    CredentialsRead = 'CredentialsRead',
    CredentialsManage = 'CredentialsManage',
    SelfInvoicing = 'SelfInvoicing',
    TaxRepresentative = 'TaxRepresentative',
    EnforcementOperations = 'EnforcementOperations',
    CourtBailiff = 'CourtBailiff',
    EnforcementAuthority = 'EnforcementAuthority'
}
